import { createFileRoute } from '@tanstack/react-router';

import { PatientClaimPage } from '@/features/claims';

export const Route = createFileRoute('/claim-portal')({ component: PatientClaimPage });
